import { jsx as _jsx } from "react/jsx-runtime";
import { tv } from "tailwind-variants";
const bannerVariants = tv({
    base: "flex flex-col items-center justify-between gap-2.5 rounded py-4 px-5 sm:flex-row sm:gap-5 sm:px-5",
    variants: {
        color: {
            primary: "bg-primary-2",
            secondary: "bg-gray-2",
            success: "bg-success-2",
            warning: "bg-warning-2",
            danger: "bg-danger-2",
        },
    },
    defaultVariants: {
        color: "primary",
    },
});
const Banner = ({ children, color }) => {
    return _jsx("div", { className: bannerVariants({ color }), children: children });
};
export default Banner;
